<template>
  <div class="creative-card flex items-center justify-between bg-white rounded-md py-1 cursor-pointer" @click="openCreativeModal">
    <div class="flex items-center space-x-1">
      <div class="relative">
        <template v-if="thumbnailUrl">
          <img :src="thumbnailUrl" alt="Creative" class="w-7 h-7 object-cover rounded" />
        </template>
        <template v-else>
          <div class="p-1.5 bg-[#F9F9FB] border border-grayNeutralLight rounded w-full h-full flex items-center justify-center">
            <svg width="16" height="17">
              <use xlink:href="#screen"></use>
            </svg>
          </div>
        </template>
        <span
          class="absolute inset-0 m-auto w-3.5 h-3.5 text-[#909399] bg-grayLightest inline-flex justify-center items-center rounded-full font-bold"
          v-if="creative.files"
          >{{ creative.files.length }}</span
        >
      </div>
      <div>
        <h4 class="font-semibold text-sm text-dark">{{ creative.name }}</h4>
        <CampaignStatus class="status" :status="creative.status" />
      </div>
    </div>

    <div class="flex items-center">
      <span class="text-sm text-grayNeutralDark mr-8">{{ totalSize }}</span>
      <ElButton
        v-if="$is_GD"
        :disabled="!canSendToReview(creative?.status)"
        type="primary"
        icon="el-icon-s-promotion"
        size="small"
        class="text-sm font-medium"
        @click.stop="sendToReview"
      >
        Send to review
      </ElButton>
      <ElButton
        v-if="canRequestRevisionOrApprove(creative?.status)"
        type="primary"
        size="small"
        class="text-sm font-medium bg-primary/10 text-primary"
        @click.stop="openCreativeModal"
        >Review</ElButton
      >
      <ElButton
        v-if="canDownload(creative?.status)"
        :loading="isDownloading"
        type="primary"
        icon="el-icon-download"
        size="small"
        class="text-sm font-medium bg-primary/10 text-primary"
        @click.stop="downloadCreativeFile(creative)"
      >
        Download
      </ElButton>
      <ElButton
        v-if="$is_GD"
        :disabled="!canDeleteCreative(creative?.status)"
        type="text"
        :class="['text-grayNeutralDark p-1', { 'is-disabled opacity-50': !canDeleteCreative(creative?.status) }]"
        @click.stop="onDeleteClick"
      >
        <svg width="16" height="16">
          <use :xlink:href="`#delete-slim`"></use>
        </svg>
      </ElButton>
      <ElButton @click.stop="openCreativeModal" type="text" icon="el-icon-arrow-right" class="text-grayNeutralDark p-1 m-0"> </ElButton>
    </div>
  </div>
</template>

<script>
import CreativeModal from '@/components/social-products/social-boost/modal/creative/CreativeModal.vue'
import SendToReview from '@/components/social-products/social-boost/modal/creative/SendToReview.vue'
import Approve from '@/components/social-products/social-boost/modal/creative/Approve.vue'
import LayoutModalSlider from '@/components/social-products/social-boost/modal/creative/LayoutSlider.vue'
import CampaignStatus from '@/components/social-products/social-boost/parts/CampaignStatus.vue'
import CreativesMixin from '@/mixins/social-products/Creatives.js'

export default {
  name: 'CreativeCard',
  mixins: [CreativesMixin],
  components: {
    CreativeModal,
    CampaignStatus,
  },
  props: {
    creative: {
      type: Object,
      required: true,
    },
    flightStatus: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    thumbnailUrl() {
      if (this.creative.files && this.creative.files.length > 0) {
        const file = this.creative.files[0]
        const thumb = file.thumbnail_url || file.url
        return thumb ? this.imageSignature(thumb) : ''
      }
      return ''
    },
    totalSize() {
      if (!this.creative.files || !this.creative.files.length) return this.formatSize(0)
      const total = this.creative.files.reduce((sum, f) => sum + (f.size || 0), 0)
      return this.formatSize(total)
    },
  },
  methods: {
    imageSignature(img) {
      return this.signature(img, 'socialproducts', 1)
    },
    sendToReview() {
      this.$Modal.init(
        {
          propsData: {
            component: SendToReview,
            meta: { creative: this.creative },
            size: '480px',
          },
          callback(payload) {
            if (payload.event === 'modal:close') {
            }
          },
        },
        this
      )
    },
    approve() {
      this.$Modal.init(
        {
          propsData: {
            component: Approve,
            meta: { creative: this.creative },
            size: '480px',
          },
          callback(payload) {
            if (payload.event === 'modal:close') {
            }
          },
        },
        this
      )
    },
    formatSize(size) {
      if (!size || isNaN(size)) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(size) / Math.log(1024))
      const result = size / Math.pow(1024, i)
      return result.toFixed(1) + ' ' + units[i]
    },
    onDeleteClick() {
      this.$emit('delete', this.creative)
    },
    openCreativeModal() {
      this.$Modal.init(
        {
          propsData: {
            component: CreativeModal,
            meta: {
              creative_id: this.creative.id,
              sendToReview: this.sendToReview,
              approve: this.approve,
              flightStatus: this.flightStatus,
            },
            size: '1200px',
          },
          layout: LayoutModalSlider,
          callback: (payload) => {
            if (payload.event === 'modal:close') {
              this.$Modal.bus.$emit('reload:creatives')
            }
          },
        },
        this
      )
    },
  },
}
</script>
